import request from '@/utils/httpRequest'
/*
 * @author: xz
 * */
/*
 * @Description: 应用设置
 * */
export function userservice (code) {
  return request({
    url: '/api/admin/front/app/' + code,
    method: 'get'
  })
}

/*
 * @Description: 根据域名获取fid和code
 * */
export function getFid (query) {
  return request({
    url: '/api/admin/front/group/web',
    method: 'get',
    params: query
  })
}

/*
 * @Description: 获取地区和部门接口
 * */
export function getarea (code) {
  return request({
    url: '/api/admin/front/area/' + code,
    method: 'get'
  })
}

/*
 * @Description: 获取根部门获取所有的子部门
 * */
export function getcodename (code) {
  return request({
    url: '/api/admin/front/group/web/department-code-name?departmentCode=' + code,
    method: 'get'
  })
}
/*
 * @Description: 获取广告版位
 * */
export function getfrontslot (query) {
  return request({
    url: '/api/portal/front/slot',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/userservice/index.js